import $$ from 'cmn-utils'

const baseUrl = "/api/datav/electricity/";
export default {

    totalBase: (params) => {
        return $$.get(baseUrl + 'total-base', params)
    },
}